import loadable from "@loadable/component";
import { PATH } from "contants/path";

const AuthPage = loadable(() => import("pages/LayoutAuthUser"));
const Login = loadable(() => import("pages/LayoutAuthUser/Login"));
const Register = loadable(() => import("pages/LayoutAuthUser/Register"));
const Recovery = loadable(() => import("pages/LayoutAuthUser/Recovery"));

const HomePage = loadable(() => import("pages/HomePage"));
const NewsPage = loadable(() => import("pages/NewsPage"));

const BonusPage = loadable(() => import("pages/BonusPage"));

const SubGamPage = loadable(() => import("pages/GamePage/pages/SubGamePage"));
// const CategoryViewDetail = loadable(
//   () => import("pages/GamePage/pages/CategoryViewDetail")
// );

const TournamentsPage = loadable(() => import("pages/TournamentsPage"));

export const mainRouter = {
  children: [
    {
      path: PATH.home,
      element: <HomePage />,
    },

    {
      path: PATH.subGamePage,
      element: <SubGamPage />,
    },

    {
      element: <AuthPage />,
      children: [
        {
          path: PATH.login,
          element: <Login />,
        },
        {
          path: PATH.register,
          element: <Register />,
        },
        {
          path: PATH.recovery,
          element: <Recovery />,
        },
      ],
    },
    {
      path: PATH.newsPage,
      element: <NewsPage />,
    },
    {
      path: PATH.bonusPage,
      element: <BonusPage />,
    },

    {
      path: PATH.tournamentsPage,
      element: <TournamentsPage />,
    },
  ],
};
